import React, { useCallback } from 'react';
import { useFetchedPromptVariables } from '../hooks/useFetchedPromptVariables';
import { VariableList } from '../components/VariableList';
import { VariableBox } from '../components/VariableBox';
import { PromptVariable } from '../../types';
import { useUpdateVariableMutation } from '../hooks/useUpdateVariableMutation';
import { useCreateVariableMutation } from '../hooks/useCreateVariableMutation';

export const VariablesTab = (props: {
  selectedVariable: PromptVariable | null;
  onVariableSelected: (promptVariable: PromptVariable | null) => void;
}) => {
  const { selectedVariable, onVariableSelected } = props;
  const { mutate: createVariableMutation } = useCreateVariableMutation();
  const { mutate: updateVariableMutation } = useUpdateVariableMutation();
  const { query: variablesQuery, queryStatusComponent: variablesQueryStatusComponent } =
    useFetchedPromptVariables();

  const onUpdate = useCallback(
    (promptVariable: PromptVariable) =>
      promptVariable.id
        ? updateVariableMutation(promptVariable)
        : createVariableMutation(promptVariable),
    [updateVariableMutation, createVariableMutation]
  );

  return variablesQuery.data ? (
    <div className="growegy-ai__variables-tab-container">
      <VariableList selectedVariable={selectedVariable} onVariableSelected={onVariableSelected} />
      {selectedVariable && <VariableBox variable={selectedVariable} onUpdate={onUpdate} />}
    </div>
  ) : (
    variablesQueryStatusComponent
  );
};
